export const MAP_LAYERS_PANEL_WIDTH_PX = 350;
export const MAP_LAYERS_PANEL_CONTROLS_GAP_PX = 16;
export const MAP_CONTROLS_RIGHT_PX = 10; // Matches Mapbox NavigationControl default margin
